import { createClient } from 'contentful';
import config from 'js/config/config';

let client;
export const getContentfulClient = () => {
  if (client) return client;

  const cacheDomain = import.meta.env.VITE_CONTENTFUL_CACHE_DOMAIN || 'cdn.contentful.com';

  client = createClient({
    space: config.CONTENTFUL_SPACE_ID,
    environment: config.CONTENTFUL_ENVIRONMENT,
    accessToken: config.CONTENTFUL_CDN_TOKEN,
    host: cacheDomain,
    responseLogger: response => {
      if (response.data && response.data.includes && cacheDomain !== 'cdn.contentful.com') {
        response.data.includes.Asset?.forEach(asset => {
          if (asset.fields && asset.fields.file && asset.fields.file.url) {
            asset.fields.file.url = asset.fields.file.url
              .replace('images.ctfassets.net', cacheDomain + '/images')
              .replace('videos.ctfassets.net', cacheDomain + '/videos');
          }
        });
      }
    }
  });

  return client;
};
